module.exports = __webpack_public_path__ + "static/separador-tsi-a915820a822c5c3d45a56bbed626bec0.jpg";